module.exports = __webpack_public_path__ + "static/media/esporte-highlight.de2d8f39.jpg";